export default __webpack_public_path__ + "static/media/icon-reachforward.68b983cb.svg";